import { ImageUp } from 'lucide-react'

type FileDropProps = {
  file: File | null
  onFileChange: (file: File | null) => void
  disabled?: boolean
}

export function FileDrop({ file, onFileChange, disabled = false }: FileDropProps) {
  return (
    <label className={disabled ? 'fileDrop fileDrop-disabled' : 'fileDrop'}>
      <input
        type="file"
        accept="image/png,image/jpeg,image/webp"
        disabled={disabled}
        onChange={(event) => {
          const nextFile = event.currentTarget.files?.item(0) ?? null
          onFileChange(nextFile)
        }}
      />
      <ImageUp size={28} aria-hidden="true" />
      <span>{file ? file.name : 'Select jewelry, charm, logo, or packaging image'}</span>
    </label>
  )
}
